import { Component, OnInit } from "@angular/core";
import { DeviceDetectorService } from "ngx-device-detector";

@Component({
  selector: "app-blog-slider",
  templateUrl: "./blog-slider.component.html",
  styleUrls: ["./blog-slider.component.css"],
})
export class BlogSliderComponent implements OnInit {
  posterSrc: string;
  isMobile: boolean;

  constructor(private deviceService: DeviceDetectorService) {
    this.isMobile = deviceService.isMobile();
  }

  ngOnInit() {
    this.posterSrc = "assets/images/sportstv/blog-mainboard.jpg";
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/views/blog/widgets/blog-slider/blog-slider.component.ts